<script lang="ts">
import type { PrimitiveProps } from '@/Primitive'

export interface SelectSeparatorProps extends PrimitiveProps {}
</script>

<script setup lang="ts">
import { Primitive } from '@/Primitive'

const props = defineProps<SelectSeparatorProps>()
</script>

<template>
  <Primitive
    aria-hidden="true"
    v-bind="props"
  >
    <slot />
  </Primitive>
</template>
